export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-yvw-api.tracwater.online',
  portalId: '66e8fb0b2dd5edde86407569',
  portalTypeId: '689596b618f8a8985a2aeb91'
};
